import { render, staticRenderFns } from "./default.vue?vue&type=template&id=b7d01006"
import script from "./default.vue?vue&type=script&lang=js"
export * from "./default.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LayoutsHeaderComponent: require('/usr/src/app/components/layouts/HeaderComponent.vue').default,ModalsConnectionModalWindows: require('/usr/src/app/components/modals/ConnectionModalWindows.vue').default,LayoutsFooterComponent: require('/usr/src/app/components/layouts/FooterComponent.vue').default})
